import { View, ViewOpts } from '@play-co/timestep-core/ui';
import { RadialShine } from 'src/game/components/shared/RadialShine';
import { Match2RewardItem } from 'src/game/minigame/match2-timestep/components/Match2RewardItem';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';

export class ShinyReward extends View {
  private rewardItem: Match2RewardItem;

  constructor(opts: ViewOpts & { reward?: Match2Reward }) {
    super({ ...opts });

    new RadialShine({
      superview: this,
      centerOnOrigin: true,
      opacity: 0.3,
      scale: 1.5,
    });

    this.rewardItem = new Match2RewardItem({
      superview: this,
      size: 140,
      prefix: '+',
      labelSize: 40,
      centerOnOrigin: true,
    });

    if (opts.reward) {
      this.setReward(opts.reward);
    }
  }

  public setReward(reward: Match2Reward) {
    this.rewardItem.setReward(reward);
  }
}
